import { init } from './MallCPA';
init();
